import { Navigate } from "react-router-dom";
import { SIGNUP_PROFILE_KEY } from "@app/helpers/auth/signup.helper";
import { StorageKey } from "@app/constants";
import { useCookies } from "react-cookie";

type Props = {
  children: React.ReactNode;
};

export function PrivateRoute({ children }: Props): any {
  const [cookies] = useCookies([StorageKey.AUTH_ACCESS_TOKEN]);

  if (!!cookies?.tokens && sessionStorage.getItem(SIGNUP_PROFILE_KEY)) {
    return <Navigate to="/signup/profile" replace />;
  }

  if (cookies?.tokens) {
    return children;
  }

  return null;
}
